// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Note_buttons__33CXm"};